import { freddyTheme, useMediaQuery } from '@coolblue-development/freddy';
export function useBreakpoints() {
    const { xs, sm, md, lg, xl } = freddyTheme.breakpoint.values;
    const breakpoints = {
        isXs: useMediaQuery(`(min-width:  ${xs}) and (max-width:  ${sm})`),
        isSm: useMediaQuery(`(min-width:  ${sm}) and (max-width:  ${md})`),
        isMd: useMediaQuery(`(min-width:  ${md}) and (max-width:  ${lg})`),
        isLg: useMediaQuery(`(min-width:  ${lg}) and (max-width:  ${xl})`),
        isXl: useMediaQuery(`(min-width:  ${xl})`),
        active: 'xs',
    };
    if (breakpoints.isXs)
        breakpoints.active = 'xs';
    if (breakpoints.isSm)
        breakpoints.active = 'sm';
    if (breakpoints.isMd)
        breakpoints.active = 'md';
    if (breakpoints.isLg)
        breakpoints.active = 'lg';
    if (breakpoints.isXl)
        breakpoints.active = 'xl';
    return breakpoints;
}
//# sourceMappingURL=useBreakpoints.js.map